module.exports = __webpack_public_path__ + "static/media/logo-nav.325c3a4e.png";